import React from 'react';
import { GlobalStyles as MuiGlobalStyles } from '@mui/material';

const GlobalStyles: React.FC = () => (
  <MuiGlobalStyles
    styles={{
      body: {
        overflowX: 'hidden',
      },
    }}
  />
);

export default GlobalStyles;